var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectModeAiWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17091",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17091",
    transform: "translate(4798 14990)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15269",
    "data-name": "\\u9577\\u65B9\\u5F62 15269",
    width: 155,
    height: 155,
    transform: "translate(-4798 -14990)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D_61",
    "data-name": "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D 61",
    d: "M114,147H33A32.972,32.972,0,0,1,0,114V33A32.973,32.973,0,0,1,33,0h81a32.972,32.972,0,0,1,33,33v81a32.972,32.972,0,0,1-33,33ZM46.771,91.136h23.97l4.5,9.346c.57,1.14,1.021,2.013,1.341,2.6a5.2,5.2,0,0,0,1.558,1.644,4.644,4.644,0,0,0,2.769.778,11.4,11.4,0,0,0,4.63-1.471c3.33-1.665,5.018-3.558,5.018-5.625a11.352,11.352,0,0,0-1.471-4.413L65.723,45.706a8.383,8.383,0,0,0-2.856-3.374A7.329,7.329,0,0,0,58.8,41.207a7.686,7.686,0,0,0-4.11,1.211,7.589,7.589,0,0,0-2.9,3.2L28.427,93.992A11.334,11.334,0,0,0,26.956,98.4c0,2.067,1.688,3.931,5.018,5.539a11.418,11.418,0,0,0,4.63,1.471,4.468,4.468,0,0,0,2.769-.822,6.183,6.183,0,0,0,1.557-1.6c.317-.518.768-1.362,1.342-2.509l4.5-9.345Zm56.246-49.929c-3.675,0-5.946.786-6.749,2.336a6.973,6.973,0,0,0-.823,2.293,25.3,25.3,0,0,0-.13,2.985V96.934a13.679,13.679,0,0,0,.519,4.413,4.032,4.032,0,0,0,2.293,2.466,11.652,11.652,0,0,0,4.8.822c3.675,0,5.946-.786,6.75-2.336a7.028,7.028,0,0,0,.822-2.25,25.139,25.139,0,0,0,.13-3.029V48.908a17.324,17.324,0,0,0-.432-4.5,4.124,4.124,0,0,0-2.359-2.4A12.1,12.1,0,0,0,103.018,41.207ZM64.511,78.329H53l5.711-11.855,5.8,11.853Z",
    transform: "translate(-4794 -14986)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectModeAiWhite);
export default __webpack_public_path__ + "static/media/selectModeAIWhite.3eb06a8d9ecce9705f64b0a721fccc12.svg";
export { ForwardRef as ReactComponent };